export default (function (classObj) {
  if (!classObj.classes) {
    throw new Error('AmpApi: expected classObj to have property classes.');
  }

  if (!Array.isArray(classObj.classes)) {
    throw new Error('AmpApi: expected classObj.classes to be an array.');
  }

  return classObj.classes;
});